import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import * as Redux from 'redux'

interface IResourceState {
  url: string
  fileName: string
  username: string,
  error: string
}

interface IResourceAction extends IReducerAction {
  type: string
  resource?: IResourceState
}

const ActionTypes = {
  REQUESTREPORT: 'resources/REQUESTREPORT'
}

const initialState: IResourceState = {
  url: null,
  fileName: null,
  username: null,
  error: null,
}

const functionalReducer = new FunctionalReducer<IResourceState, IResourceAction>(initialState)
  .whenTypeIs(ActionTypes.REQUESTREPORT, () => {
    return {
      url: initialState.url,
      fileName: initialState.fileName,
      username: initialState.username,
      error: initialState.error,
    }
  })

export {
  functionalReducer,
  ActionTypes,
  IResourceState,
  IResourceAction
}



// WEBPACK FOOTER //
// ./src/app/redux/Resources/reducer/index.ts